import { ELoginAs, ILoginMobileParams, ILoginResponse, authenticationAPIController } from '@aqx-core/common/api/auth';
import { centroidLoginAPIController } from '@aqx-core/common/api/centroid-login';
import { metatraderLoginAPIController } from '@aqx-core/common/api/metatrader-login';
import { omsLoginAPIController } from '@aqx-core/common/api/oms-login';
import { IAPIControllerCallbacks } from '@aqx-core/common/api/types';
import { ITradingAccount } from '@aqx-core/common/api/user-account';

import { IViewLoginParams, IViewTradingAccountBalances } from './types';

export const extractBalanceFields = (account: Partial<ITradingAccount>): IViewTradingAccountBalances => {
  const fields: (keyof IViewTradingAccountBalances)[] = [
    'equity',
    'margin',
    'balance',
    'freeMargin',
    'profitLoss',
    'marginLevel',
    'marginCall',
    'marginStopout',
    'notional',
    'commission',
    'swaps',
    'availableWithdraw',
    'credit',
    'tradingState',
    'buyingPower',
    'pnlGross'
  ];
  return Object.fromEntries(fields.map((field) => [field, account[field]])) as IViewTradingAccountBalances;
};

export const getWebLoginAPICallMap = (
  params: IViewLoginParams,
  callbacks: IAPIControllerCallbacks<ILoginResponse>
): {
  [key in ELoginAs]: () => Promise<void>;
} => {
  return {
    [ELoginAs.LIVE]: () => authenticationAPIController.loginWebCRM(params, callbacks),
    [ELoginAs.MT4_LIVE]: () => metatraderLoginAPIController.loginWebMT4Live(params, callbacks),
    [ELoginAs.MT4_DEMO]: () => metatraderLoginAPIController.loginWebMT4Demo(params, callbacks),
    [ELoginAs.MT5_LIVE]: () => metatraderLoginAPIController.loginWebMT5Live(params, callbacks),
    [ELoginAs.MT5_DEMO]: () => metatraderLoginAPIController.loginWebMT5Demo(params, callbacks),
    [ELoginAs.CENTROID_LIVE]: () => centroidLoginAPIController.loginWebCentroidLive(params, callbacks),
    [ELoginAs.CENTROID_DEMO]: () => centroidLoginAPIController.loginWebCentroidDemo(params, callbacks),
    [ELoginAs.OMS_LIVE]: () => omsLoginAPIController.loginWebOMSLive(params, callbacks),
    [ELoginAs.OMS_DEMO]: () => omsLoginAPIController.loginWebOMSDemo(params, callbacks)
  };
};

export const getMobileLoginAPICallMap = (
  params: ILoginMobileParams,
  callbacks: IAPIControllerCallbacks<ILoginResponse>
): {
  [key in ELoginAs]: () => Promise<void>;
} => {
  return {
    [ELoginAs.LIVE]: () => authenticationAPIController.loginMobileCRM(params, callbacks),
    [ELoginAs.MT4_LIVE]: () => metatraderLoginAPIController.loginMobileMT4Live(params, callbacks),
    [ELoginAs.MT4_DEMO]: () => metatraderLoginAPIController.loginMobileMT4Demo(params, callbacks),
    [ELoginAs.MT5_LIVE]: () => metatraderLoginAPIController.loginMobileMT5Live(params, callbacks),
    [ELoginAs.MT5_DEMO]: () => metatraderLoginAPIController.loginMobileMT5Demo(params, callbacks),
    [ELoginAs.CENTROID_LIVE]: () => centroidLoginAPIController.loginMobileCentroidLive(params, callbacks),
    [ELoginAs.CENTROID_DEMO]: () => centroidLoginAPIController.loginMobileCentroidDemo(params, callbacks),
    [ELoginAs.OMS_LIVE]: () => omsLoginAPIController.loginMobileOMSLive(params, callbacks),
    [ELoginAs.OMS_DEMO]: () => omsLoginAPIController.loginMobileOMSDemo(params, callbacks)
  };
};
